// @mui
import { useTheme, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';

// hooks
import { useOffSetTop } from 'src/hooks/use-off-set-top';
import { useResponsive } from 'src/hooks/use-responsive';
// components
import Logo from 'src/components/logo';
//
import { HEADER } from '../config-layout';
import { navConfig } from './config-navigation';
import NavMobile from './nav/mobile';
import NavDesktop from './nav/desktop';
import AuthButton from 'src/components/buttons/buttons';
//
import { useSession } from 'next-auth/react';
import DashboardButton from 'src/components/buttons/dashboardButton';

// ----------------------------------------------------------------------

export default function Header() {
  const theme = useTheme();
  const mdUp = useResponsive('up', 'md');
  const isLight = theme.palette.mode === 'light';

  const { data: session } = useSession();
  let authenticated = false;
  if (session && session.user) {
    authenticated = true;
  }

  const offsetTop = useOffSetTop(HEADER.H_DESKTOP);

  return (
    <AppBar
      sx={{
        background: offsetTop
          ? alpha(theme.palette.background.default, 0.8)
          : 'transparent',
        backdropFilter: offsetTop ? 'blur(20px)' : 'none',
        boxShadow: 'none',
        borderBottom: offsetTop
          ? `1px solid ${alpha(theme.palette.divider, 0.08)}`
          : 'none',
        transition: 'all 0.3s ease',
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          height: {
            xs: HEADER.H_MOBILE,
            md: HEADER.H_DESKTOP,
          },
          transition: theme.transitions.create(['height'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter,
          }),
          ...(offsetTop && {
            height: {
              md: HEADER.H_DESKTOP_OFFSET,
            },
          }),
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            height: 1,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {/* Logo */}
          <Logo />

          {/* Spacer */}
          <Box sx={{ flexGrow: 1 }} />

          {/* Desktop Navigation */}
          {mdUp && <NavDesktop offsetTop={offsetTop} data={navConfig} />}

          {/* Action Buttons */}
          <Stack
            direction="row"
            alignItems="center"
            spacing={2}
          >
            {!authenticated && (
              <Button
                href="/va-login"
                variant="outlined"
                sx={{ display: { xs: 'none', sm: 'inline-flex' } }}
              >
                VA Login
              </Button>
            )}
            {authenticated && <DashboardButton />}
            <AuthButton />
            {!mdUp && <NavMobile offsetTop={offsetTop} data={navConfig} />}
          </Stack>
        </Container>
      </Toolbar>
    </AppBar>
  );
}
